import { AuditActionType, AuditActions, AuditActionsLabels } from "../constants";

export interface AuditLogDto {
  readonly AuditId: number;
  readonly Username: string;
  readonly UserId: number | null;
  readonly deviceName: string;
  readonly deviceUserName: string;
  readonly IpAddress: string;
  readonly Date: string;
  readonly Time: string;
  // Ενημέρωση τύπου: Το Action στο DTO μπορεί να είναι ο αριθμός (ή string αναλόγως τι στέλνει το backend)
  readonly Action: AuditActionType; 
  readonly TableName: string;
  readonly RecordId: number;
  readonly ColumnName: string;
  readonly BeforeValue: string;
  readonly AfterValue: string;
}

export interface AuditLogFieldDefinition {
  readonly name: keyof AuditLogDto;
  readonly label: string;
  // Προσθέσαμε το "select" στον τύπο για να μπορούμε να το χειριστούμε ως πεδίο επιλογής (Dropdown) στα φίλτρα
  readonly type: "number" | "date" | "string" | "select";
  readonly required: boolean;
  // Επιπλέον ιδιότητα για τα options αν είναι τύπου select
  readonly options?: readonly { readonly value: number; readonly label: string }[];
}

export const auditLogFields: readonly AuditLogFieldDefinition[] = [
  { name: "Username", label: "Όνομα Χρήστη", type: "string", required: true },
   {
    name: "Date",
    label: "Ημερομηνία",
    type: "date",
    required: true,
  },
    {
    name: "Time",
    label: "Ώρα",
    type: "date",
    required: true,
  },
  { name: "IpAddress", label: "IP", type: "string", required: true },
  { name: "deviceName", label: "User Agent", type: "string", required: true },
  {
    name: "deviceUserName",
    label: "Χρήστης Windows",
    type: "string",
    required: true,
  },
  { 
    name: "Action", 
    label: "Ενέργεια", 
    type: "select", // Το αλλάζουμε σε select για να χτιστεί σωστά το Dropdown στο UI
    required: true,
    options: Object.entries(AuditActions).map(([key, value]) => ({
      value: value,
      label: AuditActionsLabels[value as AuditActionType],
    }))
  },
  { name: "TableName", label: "Όνομα Πίνακα", type: "string", required: true },
  { name: "RecordId", label: "ID Εγγραφής", type: "number", required: true },
  { name: "ColumnName", label: "Όνομα Στήλης", type: "string", required: true },
  {
    name: "BeforeValue",
    label: "Προηγούμενη Τιμή",
    type: "string",
    required: true,
  },
  { name: "AfterValue", label: "Νέα Τιμή", type: "string", required: true },
] as const;

export const auditLogFilters = auditLogFields.filter((f) =>
  ["TableName", "Action", "DateTimeStamp", "UserId"].includes(f.name),
);